import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTelegramCommunity = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M18.1667 8.19922L6.5 12.3659L9.83333 14.0326L14.8333 10.6992L11.5 14.8659L16.5 18.1992L18.1667 8.19922Z",
		stroke: "white",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13 24C19.0753 24 24 19.0753 24 13C24 6.9247 19.0753 2 13 2C6.9247 2 2 6.9247 2 13C2 19.0753 6.9247 24 13 24Z",
		stroke: "white",
		strokeWidth: 1.25,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgTelegramCommunity;
